import api from '../api';

class PropertyPaymentsService {
  // Get property details
  getPropertyDetails(propertyId) {
    return api.get(`/properties/${propertyId}`);
  }

  // Get property payments
  getPropertyPayments(propertyId, params = {}) {
    return api.get(`/properties/${propertyId}/payments`, { params });
  }

  // Get property payments statistics
  getPropertyPaymentsStatistics(propertyId) {
    return api.get(`/properties/${propertyId}/payments/statistics`);
  }

  // Send payment reminder
  sendPaymentReminder(paymentId) {
    return api.post(`/payments/${paymentId}/send-reminder`);
  }

  // Get payment details
  getPaymentDetails(paymentId) {
    return api.get(`/payments/${paymentId}`);
  }

  // Update payment
  updatePayment(paymentId, data) {
    return api.put(`/payments/${paymentId}`, data);
  }

  // Delete payment
  deletePayment(paymentId) {
    return api.delete(`/payments/${paymentId}`);
  }

  // Mark payment as paid
  markAsPaid(paymentId) {
    return api.post(`/payments/${paymentId}/mark-as-paid`);
  }

  // Mark payment as paid (matching component usage)
  markPaymentAsPaid(rentId, paymentId) {
    return api.post(`/rents/${rentId}/payments/${paymentId}/mark-as-paid`);
  }

  // Export payments
  exportPayments(propertyId, format = 'csv') {
    return api.get(`/properties/${propertyId}/payments/export`, {
      params: { format }
    });
  }

  // Get payment history
  getPaymentHistory(propertyId) {
    return api.get(`/properties/${propertyId}/payments/history`);
  }

  // Get overdue payments
  getOverduePayments(propertyId) {
    return api.get(`/properties/${propertyId}/payments/overdue`);
  }

  // Get payment summary
  getPaymentSummary(propertyId) {
    return api.get(`/properties/${propertyId}/payments/summary`);
  }

  // Get guardian payments
  getGuardianPayments(guardianId) {
    return api.get(`/guardians/${guardianId}/payments`);
  }

  // Get rent payments
  getRentPayments(rentId) {
    return api.get(`/rents/${rentId}/payments`);
  }

  // Create payment
  createPayment(data) {
    return api.post('/payments', data);
  }

  // Get payment statuses
  getPaymentStatuses() {
    return api.get('/payments/statuses');
  }

  // Get payment types
  getPaymentTypes() {
    return api.get('/payments/types');
  }

  // Get payment methods
  getPaymentMethods() {
    return api.get('/payments/methods');
  }

  // Get payment reports
  getPaymentReports(propertyId, params = {}) {
    return api.get(`/properties/${propertyId}/payments/reports`, { params });
  }

  // Get payment analytics
  getPaymentAnalytics(propertyId) {
    return api.get(`/properties/${propertyId}/payments/analytics`);
  }

  // Get payment trends
  getPaymentTrends(propertyId) {
    return api.get(`/properties/${propertyId}/payments/trends`);
  }

  // Get payment forecasts
  getPaymentForecasts(propertyId) {
    return api.get(`/properties/${propertyId}/payments/forecasts`);
  }

  // Get payment alerts
  getPaymentAlerts(propertyId) {
    return api.get(`/properties/${propertyId}/payments/alerts`);
  }

  // Set payment alert
  setPaymentAlert(propertyId, data) {
    return api.post(`/properties/${propertyId}/payments/alerts`, data);
  }

  // Delete payment alert
  deletePaymentAlert(propertyId, alertId) {
    return api.delete(`/properties/${propertyId}/payments/alerts/${alertId}`);
  }

  // Get payment notifications
  getPaymentNotifications(propertyId) {
    return api.get(`/properties/${propertyId}/payments/notifications`);
  }

  // Mark notification as read
  markNotificationAsRead(propertyId, notificationId) {
    return api.put(`/properties/${propertyId}/payments/notifications/${notificationId}/read`);
  }

  // Get payment settings
  getPaymentSettings(propertyId) {
    return api.get(`/properties/${propertyId}/payments/settings`);
  }

  // Update payment settings
  updatePaymentSettings(propertyId, data) {
    return api.put(`/properties/${propertyId}/payments/settings`, data);
  }
}

export default new PropertyPaymentsService();